// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b6f31393","239":"8f785fb9","453":"ecd4e62d","455":"a153e8f6"}[chunkId] + ".chunk.js";
};